import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Box } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import { THEME_COLOR, FONT_FAMILY } from '../Constant';

function Header({ onMenuClick }) {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };
  return (
    <AppBar position="fixed" elevation={0} sx={{ background: THEME_COLOR, color: '#fff', borderBottom: '1px solid #222', zIndex: 1201, fontFamily: FONT_FAMILY }}>
      <Toolbar sx={{ justifyContent: 'space-between', minHeight: 56 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={onMenuClick}
            sx={{ mr: 2, display: { xs: 'inline-flex', sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ fontWeight: 700, letterSpacing: 1, fontSize: 20, fontFamily: FONT_FAMILY }}>
            Admin AgentZena
          </Typography>
        </Box>
        <IconButton onClick={handleLogout} sx={{ color: '#fff' }} title="Logout">
          <LogoutIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
